<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    v-drag
  >
    <a-button
      @click="setCopyFormData"
      size="small"
      v-if="
        copyFormData.fileLink &&
        modalConfig.type !== 'iteration' &&
        modalConfig.type !== 'update'
      "
      >粘贴</a-button
    >
    <a-form
      :model="formState"
      ref="formRef"
      :rules="rules"
      :labelCol="{
        span: 5,
      }"
    >
      <a-form-item label="主题" name="theme">
        <a-select
          v-model:value="formState.theme"
          :options="dataBaseThemeOptions"
          placeholder="请输入主题"
          :disabled="modalConfig.type === 'iteration'"
          allowClear
          v-if="
            formState.theme !== undefined &&
            !Boolean(formState.theme) &&
            dataBaseThemeOptions.length > 0
          "
        >
        </a-select>
        <a-input
          v-else
          v-model:value="formState.theme"
          placeholder="请输入主题"
          :disabled="modalConfig.type === 'iteration'"
        ></a-input>
      </a-form-item>

      <a-form-item label="项目阶段" name="projectLifeCycle">
        <a-select
          v-model:value="formState.projectLifeCycle"
          placeholder="项目阶段"
          :options="projectLifeCycleOptions"
          :disabled="modalConfig.type === 'iteration'"
        >
        </a-select>
      </a-form-item>

      <a-form-item label="文件名称" name="fileName">
        <a-input
          v-model:value="formState.fileName"
          placeholder="请输入文件名称"
          :disabled="modalConfig.type === 'iteration'"
        ></a-input>
      </a-form-item>

      <a-form-item label="文件类型" name="fileType">
        <a-select
          v-model:value="formState.fileType"
          placeholder="文件类型"
          :disabled="modalConfig.type === 'iteration'"
        >
          <a-select-option value="input">输入文件</a-select-option>
          <a-select-option value="output">输出文件</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="文件" name="fileLink">
        <upload
          @setUploadFileUrl="setUploadFileUrl"
          :echoFile="formState.fileLink"
          ref="fileRef"
        ></upload>
      </a-form-item>

      <a-form-item label="文件版本" name="version">
        <a-input
          v-model:value="formState.version"
          placeholder="请输入文件版本"
        ></a-input>
      </a-form-item>

      <a-form-item label="产线资料" name="isProductionData">
        <a-switch
          checked-children="是"
          un-checked-children="否"
          v-model:checked="formState.isProductionData"
        />
      </a-form-item>

      <a-form-item label="体系资料" name="isSystemData">
        <a-switch
          checked-children="是"
          un-checked-children="否"
          v-model:checked="formState.isSystemData"
        />
      </a-form-item>

      <a-form-item label="工作记录" name="workRecords">
        <a-textarea
          v-model:value="formState.workRecords"
          auto-size
        ></a-textarea>
      </a-form-item>

      <div style="color: red; text-align: right" v-if="isSetCopyData">
        此文件的设计人为{{ copyFormData.username }}
      </div>
    </a-form>
  </a-modal>
</template>
   
<script>
import { defineComponent, reactive, ref, inject, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  insertRNDDataLib,
  updateDataLib,
  getRNDDataLibList,
} from "@/request/view/project";
import customSelect from "@/views/rdmanagement/components/database/customSelect.vue";
import {
  fileTypeOptions,
  libTypeOptions,
  projectLifeCycleOptions,
} from "@/views/rdmanagement/components/database/options";
import upload from "@/views/rdmanagement/components/database/multipleUpload.vue";
import { useStore } from "vuex";
import { debounce, timeStampToTime, Toast } from "@/utils";

export default defineComponent({
  components: { customSelect, upload },
  setup(props, context) {
    const route = useRoute();
    const store = useStore();

    const fileRef = ref();

    const dataBaseLibtype = inject("dataBaseLibtype", null);

    const isSetCopyData = ref(false);

    const copyFormData = reactive({
      fileName: null,
      fileLink: null,
      version: null,
      username: null,
      userId: null,
    });

    const dataBaseKey = inject("dataBaseKey", null);
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const formState = reactive({
      theme: null,
      dataLibType: null,
      fileLink: null,
      fileName: null,
      fileType: null,
      id: null,
      isProductionData: false,
      isSystemData: false,
      projectLifeCycle: null,
      projectLifeCycleId: null,
      structureName: null,
      uploadTime: null,
      userId: null,
      username: null,
      version: null,
      workRecords: null,
    });

    const rules = {
      theme: [
        {
          required: true,
          message: "请输入主题",
          trigger: "blur",
          type: "string",
        },
      ],
      projectLifeCycle: [
        {
          required: true,
          message: "请选择项目阶段",
          trigger: "blur",
          type: "string",
        },
      ],
      fileName: [
        {
          required: true,
          message: "请输入文件名称",
          trigger: "blur",
          type: "string",
        },
      ],
      dataLibType: [
        {
          required: true,
          message: "请选择资料库类型",
          trigger: "blur",
          type: "string",
        },
      ],
      fileType: [
        {
          required: true,
          message: "请选择文件类型",
          trigger: "blur",
          type: "string",
        },
      ],
      fileLink: [
        {
          required: true,
          message: "请上传文件",
          trigger: "blur",
          type: "string",
        },
      ],
      version: [
        {
          required: true,
          message: "请输入文件版本",
          trigger: "blur",
          type: "string",
        },
      ],
      // isProductionData: [
      //   {
      //     required: true,
      //     message: "请选择文件是否为产线资料",
      //     trigger: "blur",
      //     type: "any",
      //   },
      // ],
      // isSystemData: [
      //   {
      //     required: true,
      //     message: "请选择文件是否为体系资料",
      //     trigger: "blur",
      //     type: "any",
      //   },
      // ],
    };

    const setEchoFile = () => {
      nextTick(() => {
        fileRef.value.setEchoFile(formState.fileLink);
      });
    };

    const setCopyFormData = () => {
      const { fileLink, fileName, version, userId, username } = copyFormData;

      formState.fileLink = fileLink;
      formState.fileName = fileName;
      formState.version = version;
      formState.fileType = "input";
      isSetCopyData.value = true;
      setEchoFile();
    };

    const getCopyData = () => {
      const data = localStorage.getItem("sky-eye-copy");
      if (data) {
        const { query } = JSON.parse(data);
        const copyData = JSON.parse(query);
        copyFormData.fileName = copyData.fileName;
        copyFormData.version = copyData.version;
        copyFormData.fileLink = copyData.fileLink;
        copyFormData.userId = copyData.userId;
        copyFormData.username = copyData.username;
      }
    };

    const dataBaseThemeOptions = ref([]);

    const getDataBaseTheme = () => {
      dataBaseThemeOptions.value.length = 0;
      getRNDDataLibList({
        dataLibType: dataBaseLibtype,
        structureName:
          store.state.user.user.secondaryDepartment ||
          store.state.user.user.firstLevelDepartment,
        projectLifeCycleId: route.query.projectId,
      }).then((res) => {
        if (res.code === 200 && res.data) {
          Object.keys(res.data).forEach((key) => {
            dataBaseThemeOptions.value.push({
              label: key,
              value: key,
            });
          });
        }
      });
    };

    const showmodal = (options) => {
      getDataBaseTheme();
      getCopyData();
      const { title, data, type, libName } = options;
      modalConfig.title = title;
      modalConfig.type = type;
      if (type === "insert") {
        formState.projectLifeCycle = route.query.projectLifeCycle;
        formState.theme = libName ? libName : null;
        formState.dataLibType = dataBaseKey.value;
      }

      if (type === "update" || type === "iteration") {
        Object.keys(formState).forEach((key) => {
          if (type === "iteration" && (key === "fileLink" || key === "id"))
            return;
          formState[key] = data[key];
        });
        setEchoFile();
      }
      modalConfig.visible = true;
    };
    const setUploadFileUrl = (fileList) => {
      const fileLinkList = [];
      fileList.value.forEach((file) => {
        fileLinkList.push(file.url);
      });
      formState.fileLink = fileLinkList.toString();
      if (isSetCopyData.value) {
        isSetCopyData.value = false;
      }
    };

    const formRef = ref();

    const resetForm = () => {
      formRef.value.clearValidate();
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      fileRef.value.resetFileList();
      modalConfig.title = null;
      modalConfig.type = null;
      modalConfig.visible = false;

      copyFormData.fileName = null;
      copyFormData.fileLink = null;
      copyFormData.version = null;
      copyFormData.username = null;
      copyFormData.userId = null;
      isSetCopyData.value = false;
    };

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then((res) => {
          let reqFn = updateDataLib;
          if (
            modalConfig.type === "insert" ||
            modalConfig.type === "iteration"
          ) {
            reqFn = insertRNDDataLib;
            const { nickName, id, secondaryDepartment, firstLevelDepartment } = store.state.user.user;
            formState.username = nickName;
            formState.userId = id;
            formState.structureName = secondaryDepartment || firstLevelDepartment;
            formState.uploadTime;
            formState.projectLifeCycleId = route.query.projectId;
          }

          if (isSetCopyData.value) {
            formState.username = copyFormData.username;
          }

          formState.uploadTime = timeStampToTime("", "upload");
          reqFn(formState).then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            context.emit("hadleUpdateTable", modalConfig.type === "insert");

            if (isSetCopyData.value) {
              localStorage.removeItem("sky-eye-copy");
            }
            resetForm();
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            err.errorFields.forEach((item) => {
              const [msg] = item.errors;
              Toast("warning", msg, 3);
            });
          }
        });
    });

    // watch(
    //   () => dataBaseKey,
    //   (val) => {
    //     formState.dataLibType = val.value;
    //   },
    //   {
    //     immediate: true,
    //     deep: true,
    //   }
    // );

    const handleCancel = () => {
      resetForm();
    };

    return {
      fileRef,
      dataBaseThemeOptions,
      copyFormData,
      isSetCopyData,
      setCopyFormData,
      getCopyData,
      modalConfig,
      handleOk,
      libTypeOptions,
      handleCancel,
      showmodal,
      projectLifeCycleOptions,
      setUploadFileUrl,
      fileTypeOptions,
      formState,
      formRef,
      rules,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>